import request from "@/utils/request";

export function loginByCode(code) {
  return request({
    url: '/loginByCode',
    method: 'post',
    data: {
      code,
    }
  });
}
